import type { ComponentChildren } from "preact";
import { Icon } from "../demo-v2/chrome/icons.js";
import type { FlowCopy } from "./content.js";
import { COVER } from "./photos.js";

export const SHOT_SRC = "/assets/demo/c09-l.webp";

export function Phone({ children }: { readonly children: ComponentChildren }) {
  return (
    <div class="phone" data-theme="dark">
      <div class="phone-body">
        <div class="phone-glass">{children}</div>
      </div>
    </div>
  );
}

export function ScanScreen({ copy }: { readonly copy: FlowCopy }) {
  return (
    <div class="scr scr-scan">
      <img class="scr-bg" src="/assets/photos/convite-mesa.webp" alt="" loading="lazy" />
      <span class="scan-frame" />
      <div class="scan-banner" data-theme="light">
        <span class="scan-icon">
          <Icon name="qr" size={16} />
        </span>
        <span class="scan-text">
          <strong>{copy.scan}</strong>
          <span>kuori.app</span>
        </span>
        <span class="scan-open">{copy.open}</span>
      </div>
      <span class="scan-shutter" />
    </div>
  );
}

export interface InviteMockProps {
  readonly copy: FlowCopy;
  readonly host: string;
  readonly accent: string;
  readonly line: string;
  readonly typing?: boolean;
}

export function InviteMock({ copy, host, accent, line, typing = false }: InviteMockProps) {
  const [first, last] = copy.guest;
  return (
    <div class="scr scr-invite">
      <img class="scr-bg" src={COVER} alt="" loading="lazy" />
      <span class="scr-veil" />
      <div class="inv-column">
        <p class="inv-host" style={{ borderBottomColor: line }} data-testid="invite-host">
          {copy.invitedBy} {host}
        </p>
        <p class="inv-headline">
          {copy.headline[0]}
          <em>{copy.headline[1]}</em>
        </p>
        <div class="inv-card" data-theme="light">
          <p class="inv-event">{copy.scan}</p>
          <p class="inv-meta">sáb · 19h00 · 17 fotos</p>
          <div class="inv-names">
            <span class="inv-field">
              <span class="inv-label">{copy.first}</span>
              <span class={typing ? "inv-input is-typing" : "inv-input"}>
                <span class="inv-typed" style={{ "--chars": first.length }}>
                  {first}
                </span>
              </span>
            </span>
            <span class="inv-field">
              <span class="inv-label">{copy.last}</span>
              <span class={typing ? "inv-input is-typing is-second" : "inv-input"}>
                <span class="inv-typed" style={{ "--chars": last.length }}>
                  {last}
                </span>
              </span>
            </span>
          </div>
          <span class="inv-enter" style={{ background: accent }}>
            {copy.enter}
          </span>
          <p class="inv-note">{copy.noApp}</p>
        </div>
      </div>
    </div>
  );
}

export function CameraScreen({
  copy,
  flash,
}: {
  readonly copy: FlowCopy;
  readonly flash: boolean;
}) {
  return (
    <div class="scr scr-camera">
      <div class="cam-bar">
        <Icon name="x" size={16} />
        <span>{copy.scan}</span>
        <Icon name="zap" size={16} />
      </div>
      <div class="cam-view">
        <img src={SHOT_SRC} alt="" loading="lazy" />
        {flash ? <span class="cam-flash" /> : null}
      </div>
      <div class="cam-foot">
        <span class="cam-left">{copy.left}</span>
        <span class="cam-shutter" />
        <span class="cam-spacer" />
      </div>
    </div>
  );
}

export function SentScreen({ copy }: { readonly copy: FlowCopy }) {
  return (
    <div class="scr scr-sent">
      <img class="scr-bg" src={SHOT_SRC} alt="" loading="lazy" />
      <span class="scr-veil" />
      <p class="sent-chip" data-theme="light">
        <span class="sent-check" aria-hidden="true">
          <svg
            viewBox="0 0 24 24"
            width="14"
            height="14"
            fill="none"
            stroke="currentColor"
            stroke-width="2.6"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <path d="M5 12.5l4.5 4.5L19 7.5" />
          </svg>
        </span>
        {copy.sentToWall}
      </p>
    </div>
  );
}
